module.exports = __webpack_public_path__ + "img/tabs.f48aaadb.svg";